// !车牌加上中间的·
export function handleCarNum (text) {
  if (text) {
    text = text.split('')
    text.splice(2, 0, '·')
    return text.join('');
  } else {
    return text
  }
}

// !分钟转时长
export function handleMinToHour (val) {
  if (val !== null && val !== '' && val !== undefined) {
    var hours = parseInt(val / 60),
      minutes = val % 60;
    minutes = (minutes >= 10 || minutes == 0) ? minutes : `0${minutes}`;
    return `${hours}小时${minutes}分钟`;
  } else {
    return val;
  }
}


// WEBPACK FOOTER //
// ./src/utils/filters.js